<div class="row justify-content-center">
    <div class="col-md-12">
      <div class="p-4 w-75 m-auto">
        <input type="text" [(ngModel)]='term' class="form-control bg-transparent" placeholder="search..." name="" id="">
    </div>
    </div>

    <div *ngFor="let people of trendingPeople|search:term |paginate:{
            itemsPerPage:1,
            currentPage:Page,
            totalItems:totalPage
          };let i= index" class=" col-md-2">
          <div [routerLink]="['/peopledetails', people?.id]" class="">
            <div class="position-relative posterr overflow-hidden">
         <img class="w-100 rounded" [src]="imgPrefix+people?.profile_path" alt="">
         <div
         class="
           layer
           position-absolute
           d-flex
           justify-content-center
           align-items-center
         "
       >
         <h6 class="text-wight">more info..</h6>
       </div>
      </div>
          <h4 class="my-2 h5">{{people?.name}}</h4>
    </div>
  </div>
</div>
<div class="row justify-content-center">
        <div class="col-md-6">
           <pagination-controls
           previousLabel="Prev"
            nextLabel="Next"
            [responsive]="true"
            (pageChange)="handel($event)">
           </pagination-controls>
        </div>
</div>
